import { inject, Injectable } from '@angular/core'
import { injectMutation, injectQuery, injectQueryClient } from './query'
import { HttpClient } from '@angular/common/http'
import { CalendarProviderName, User } from './users.service'
import { Team } from './teams.service'
import { queryKeys } from './query-keys'
import { JoinSettings } from './settings-page/settings-page.component'

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  mutation = injectMutation()
  httpClient = inject(HttpClient)
  query = injectQuery()
  queryClient = injectQueryClient()

  getUserSettings() {
    return this.query({
      queryKey: queryKeys.users.settings,
      queryFn: () => this.httpClient.get<User & { joinSettings: JoinSettings }>('/api/users/me'),
    }).result$
  }

  getTeamSettings() {
    return this.query({
      queryKey: queryKeys.teams.settings,
      queryFn: () => this.httpClient.get<Team>('/api/teams/me'),
    }).result$
  }

  updateUserSettings() {
    return this.mutation({
      mutationFn: (user: User) => this.httpClient.patch<User>(`/api/users/me`, user),
      onSuccess: () => this.queryClient.invalidateQueries({ queryKey: queryKeys.users.me }),
    })
  }

  updateTeamSettings() {
    return this.mutation({
      mutationFn: (settings: Pick<Team, 'sendWeeklyDigestEmail'>) => this.httpClient.patch<Team>(`/api/teams/me`, settings),
      onSuccess: () => this.queryClient.invalidateQueries({ queryKey: queryKeys.teams.me }),
    })
  }

  unlinkCalendarProviderMutation() {
    return this.mutation({
      mutationFn: ({ provider }: { provider: CalendarProviderName }) => this.httpClient.delete<any>(`/api/users/me/calendar/${provider}`),
      onSuccess: () => this.queryClient.invalidateQueries({ queryKey: queryKeys.users.settings }),
    })
  }
}
